(() => {
  'use strict';

  const config = document.getElementById('clarity-analytics');
  if (!config) return;

  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const sendEvent = (name) => window.clarity('event', name);

  window.clarity('set', 'account_state', config.dataset.accountState);
  window.clarity('set', 'storefront_stage', config.dataset.storefrontStage);

  const activePredictiveSearches = new WeakSet();

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('predictive-search input[type="search"]');
    if (!input) return;

    const predictiveSearch = input.closest('predictive-search');
    if (!predictiveSearch) return;

    if (!input.value.trim()) {
      activePredictiveSearches.delete(predictiveSearch);
      return;
    }

    if (activePredictiveSearches.has(predictiveSearch)) return;

    activePredictiveSearches.add(predictiveSearch);
    sendEvent('predictive_search_used');
  });

  document.addEventListener('focusout', (event) => {
    const predictiveSearch = event.target.closest?.('predictive-search');
    if (!predictiveSearch) return;

    setTimeout(() => {
      if (!predictiveSearch.contains(document.activeElement)) {
        activePredictiveSearches.delete(predictiveSearch);
      }
    });
  });

  document.addEventListener('click', (event) => {
    const tradeCta = event.target.closest?.('[data-clarity-event="trade_apply_click"]');
    if (tradeCta) {
      sendEvent('trade_apply_click');
      return;
    }

    const predictiveSearchResult = event.target.closest?.('predictive-search [data-predictive-search] a');
    if (predictiveSearchResult) sendEvent('predictive_search_result_click');
  });
})();
